module.exports = __webpack_public_path__ + "static/media/banner_white@275x60.761b0a46.png";